import { FormikProps } from "formik";
import { useContext } from "react";
import {
  CreationsUnidentifiedRow,
  ItemViewModel,
  SubmitProgramReport,
} from "../../../../../../generated/data-contracts";
import {
  AvisEditableList,
  IAvisEditableListFieldConfig,
  IRowState,
} from "../../../../../shared/components/editableList";
import { AvisSection } from "../../../../../shared/components/form";
import {
  AvisDropdown,
  AvisInputInt,
  AvisInputMaskTiming,
  AvisInputText,
} from "../../../../../shared/components/inputs";
import { AvisContext } from "../../../../../shared/context/AvisContext";

interface IProgramReportUnidentifiedCreationsProps {
  bag: FormikProps<SubmitProgramReport>;
  bagField: keyof SubmitProgramReport;
  creationClassesPublic: ItemViewModel[];
  disabled: boolean;
  loading: boolean;
}
export function ProgramReportUnidentifiedCreations(
  props: Readonly<IProgramReportUnidentifiedCreationsProps>,
) {
  const { bag, bagField, creationClassesPublic, disabled, loading } = props;
  const { res, ctxPortalSettings } = useContext(AvisContext);
  const fieldCollection: IAvisEditableListFieldConfig<
    IRowState<CreationsUnidentifiedRow>
  >[] = [
    {
      name: "creationClassId",
      title: res("label_CreationClassName"),
      required: true,
      minWidth: 140,
      width: 140,
      maxWidth: 140,
      transformViewValue: (fieldValue) => {
        return (
          creationClassesPublic?.filter((item) => item.id == fieldValue)?.[0]
            ?.name ?? ""
        );
      },
      renderField: (field, prefix, i, val, onChange) => {
        return (
          <AvisDropdown<ItemViewModel>
            name={`${prefix}.${i}.${field.name}`}
            value={val[field.name]}
            onChange={onChange}
            className="creation-class-dropdown"
            options={creationClassesPublic}
            optionValue="id"
            optionLabel="name"
            hideClear
            required={field.required}
            disabled={disabled}
          />
        );
      },
    },
    {
      name: "creationName",
      title: res("label_Title"),
      required: true,
      width: 150,
      renderField: (field, prefix, i, val, onChange) => {
        return (
          <AvisInputText
            name={`${prefix}.${i}.${field.name}`}
            value={val[field.name]}
            onChange={onChange}
            maxLength={200}
            required={field.required}
            disabled={disabled}
            hideClear
          />
        );
      },
    },
    {
      name: "composer",
      title: res("label_Composer"),
      width: 200,
      maxWidth: 200,
      renderField: (field, prefix, i, val, onChange) => {
        return (
          <AvisInputText
            name={`${prefix}.${i}.${field.name}`}
            value={val[field.name]}
            onChange={onChange}
            maxLength={250}
            disabled={disabled}
            hideClear
          />
        );
      },
    },
    {
      name: "textAuthor",
      title: res("label_TextAuthor"),
      width: 200,
      maxWidth: 200,
      renderField: (field, prefix, i, val, onChange) => {
        return (
          <AvisInputText
            name={`${prefix}.${i}.${field.name}`}
            value={val[field.name]}
            onChange={onChange}
            maxLength={250}
            disabled={disabled}
            hideClear
          />
        );
      },
    },
    {
      name: "coFounder",
      title: res("label_CoFounder"),
      width: 200,
      maxWidth: 200,
      renderField: (field, prefix, i, val, onChange) => {
        return (
          <AvisInputText
            name={`${prefix}.${i}.${field.name}`}
            value={val[field.name]}
            onChange={onChange}
            maxLength={250}
            disabled={disabled}
            hideClear
          />
        );
      },
    },
    {
      name: "choreographer",
      title: res("label_Choreographer"),
      width: 200,
      maxWidth: 200,
      renderField: (field, prefix, i, val, onChange) => {
        return (
          <AvisInputText
            name={`${prefix}.${i}.${field.name}`}
            value={val[field.name]}
            onChange={onChange}
            maxLength={250}
            disabled={disabled}
            hideClear
          />
        );
      },
    },
    {
      name: "performer",
      title: res("label_Performer"),
      width: 200,
      maxWidth: 200,
      renderField: (field, prefix, i, val, onChange) => {
        return (
          <AvisInputText
            name={`${prefix}.${i}.${field.name}`}
            value={val[field.name]}
            onChange={onChange}
            maxLength={250}
            disabled={disabled}
            hideClear
          />
        );
      },
    },
    {
      name: "playLength",
      title: res("label_PlayLength"),
      width: 80,
      renderField: (field, prefix, i, val, onChange) => {
        return (
          <AvisInputMaskTiming
            name={`${prefix}.${i}.${field.name}`}
            value={val[field.name]?.toString()}
            disabled={disabled}
            hideClear
            onChange={onChange}
          />
        );
      },
    },
    {
      name: "playCount",
      title: res("label_PlayCount"),
      width: 75,
      renderField: (field, prefix, i, val, onChange) => {
        return (
          <AvisInputInt
            name={`${prefix}.${i}.${field.name}`}
            value={val[field.name]?.toString()}
            onChange={onChange}
            min={1}
            disabled={disabled}
            hideClear
          />
        );
      },
    },
  ];

  return (
    <AvisSection
      title={res("licensees_LicenseReports_PP_section_Unidentified")}
      textToDisplayKey="portal_LIC_ProgramReport_2"
    >
      <AvisEditableList<SubmitProgramReport, CreationsUnidentifiedRow>
        bag={bag}
        bagField={bagField}
        initValue={{
          creationName: "",
          playCount: 1,
          playLength: ctxPortalSettings?.defaultCreationTiming,
        }}
        fields={fieldCollection}
        disabled={disabled}
        loading={loading}
      />
    </AvisSection>
  );
}
